//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryMessage,
  updateMessage,
} from '@/https/user'
import { success } from '@/utils/notify'
import setScrollDomMixinKeepAlive from '@/mixins/setScrollDomMixinKeepAlive'
import TMenu from '@/TShareComponent/TMenu'

export default {
  name: 'RMessageCenter',

  components: { TMenu },

  mixins: [setScrollDomMixinKeepAlive],

  data () {
    return {
      messageList: [],
      hasReadList: [],
      active: 0,
      notReadNum: undefined,
      searchParams: { sfyddm: 0 },
    }
  },

  watch: {
    async active (val) {
      this.searchParams = {
        ...this.searchParams,
        sfyddm: val,
      }

      await this.$nextTick()
      this.$refs.search._load()
    },
  },

  methods: {
    queryMessage,

    goPage () {
      this.$router.push('/RTestHome')
    },

    scrollDom () {
      return document.getElementsByClassName('result-box')[0]
    },

    filterNotReadFlag (notice) {
      return this.hasReadList.indexOf(notice.wid) < 0
    },

    toMessageDetail (notice) {
      this.hasReadList.push(notice.wid)

      this.$router.push({
        path: '/messageDetail',
        query: { wid: notice.wid },
      })

      this.notReadNum = this.notReadNum > 0 ? this.notReadNum - 1 : undefined
    },

    doFinishLoad ({ total }) {
      if (+this.active === 0) {
        this.notReadNum = total || undefined
      }
    },

    async doAllRead () {
      const { code } = await updateMessage()

      if (+code === 0) {
        success('标记成功')
        this.$refs.search._load()
      }
    },

  },
}
